import '@babel/polyfill'
import Admincraft from 'admincraft'
import moduleInit from './module-init'
import iView from 'view-design'
// import iView from 'iview'
import envConst from './env-const'
import vuescroll from 'vuescroll'
// import statistics from './plugins/statistics'
// Admincraft.add(statistics)
Admincraft.add(moduleInit)
Admincraft.use(iView)
Admincraft.use(vuescroll)
Admincraft.use(Vue => {
  Vue.config.devtools =
    !process.env.VUE_APP_ENV ||
    !process.env.VUE_APP_ENV.match(/(production|zybproduction)/g)
})
new Admincraft({
  title: '云客服',
  router: {
    guards: ({ store }) => {
      return {
        beforeEach: (to, from, next) => {
          if (store.state.main && store.state.main.iframe.actived) {
            store.commit('main/setIframe', { actived: false })
          }
          next()
        }
      }
    }
  },
  http: {
    config: {
      baseURL: envConst.API_BASE_URL,
      withCredentials: true
    },
    interceptor: ({ router, store }) => {
      return {
        request: {
          success: config => {
            return config
          }
        },
        response: {
          success: res => {
            // console.log('qingqiu', res)
            if (
              router.history.current.path == '/register' ||
              router.history.current.path == '/register2' ||
              router.history.current.path == '/forget'
            ) {
              return res
            } else {
              switch (res.data.returnCode) {
                case '405':
                  store.commit('main/user/clear')
                  location.reload()
                  break
                case '500':
                  // iView.Message.error(res.data.returnMessage)
                  break
                default:
                  if (res.data.bean && res.data.bean.msgCode === 20001) {
                    let route = router.currentRoute
                    if (route.path !== '/login' && route.path !== '/error') {
                      if (route.query.logout) {
                        router.push('/login')
                        return res
                      } else {
                        location.href =
                          location.origin +
                          '/' +
                          location.hash.split('?')[0] +
                          'login?logout=true'
                        location.reload()
                        return Promise.reject()
                      }
                    } else {
                      return res
                    }
                  } else {
                    return res
                  }
              }
            }
          },
          error: err => {
            return Promise.reject(err)
          }
        }
      }
    }
  }
})
